<template>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Account</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Cancel Subscription</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Select from the options below to cancel your subscription.
                </span>
            </div>
        </div>

        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div v-if="userConfiguration.siActiveSubscription === 'N'" class="field">
                        <label for="cancellationResponse">Subscription Status</label>
                        <Dropdown :disabled="true" v-model="selectedActiveSubscription" :options="subscriptionTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div v-if="userConfiguration.siActiveSubscription === 'Y'" class="field">
                        <label for="cancellationResponse">Subscription Status</label>
                        <Dropdown v-model="selectedActiveSubscription" :options="subscriptionTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <div v-if="userConfiguration.siActiveSubscription === 'Y'" class="field">
                        <label for="reason">Cancellation Reason</label>
                        <InputText id="reason" v-model.trim="reason"
                                   required="true"/>
                    </div>

                    <Button v-if="userConfiguration.siActiveSubscription === 'Y'" label="Process Cancellation"
                            class="mr-2 mb-2" :loading="submitted" :disabled="submitted" @click="processCancellation"></Button>

                    <div class="field">
                        <span class="p-column-title">Turning off auto-renew will turn off your subscription at your next renewal date.</span>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import ClientService from "@/service/ClientService";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    computed: {
        subscriptionStatusLabel() {
            return this.userConfiguration.siActiveSubscription === "Y"
                ? "Active"
                : "Cancelled";
        }
    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
        } catch (e) {
            this.userStore.clearUser();
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            this.selectedActiveSubscription = this.userConfiguration.siActiveSubscription;

            console.log("this.userConfiguration = ", this.userConfiguration);

            if ((this.profile.rights === 'C') || (this.profile.rights === 'A')) {
                this.courseRights = "Yes"
            } else {
                this.courseRights = "No"
            }

        } catch (e) {
            if (e.response && e.response.status === 401) {
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }
    },
    data() {

        return {
            profile: {},
            submitted: false,
            userConfiguration: {},
            companyConfiguration: {},
            courseRights: "No",
            reason: "",
            cancellationResponse: 'N',
            selectedActiveSubscription: 'Y',
            subscriptionTypes: [
                {name: 'Active', code: 'Y'},
                {name: 'Cancelled', code: 'N'}
            ],
            confirmations: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            plans: [
                {name: 'Monthly', code: 'M'},
                {name: 'Annual', code: 'A'}
            ],
            locations: [
                {name: 'United States', code: 'US'},
                {name: 'Canada', code: 'CA'},
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Other', code: 'O'}
            ],
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click();

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        callOverview() {
            this.$router.push("siOverview");
        },
        async processCancellation() {
            if (this.submitted || !this.profile?.email) return;

            this.submitted = true;

            try {
                await ClientService.processCancellationSiClient(
                    this.profile.companyId, this.profile.email, this.reason);

                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Processed cancellation',
                    life: 3000
                });

                this.safeNavigate('/siUserSettings');

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to process cancellation. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    this.$router.replace('/siLogin');
                } else {
                    this.userStore.clearUser();
                    this.$router.replace('/siLogin');
                }
            } finally {
                this.submitted = false;
            }
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
